import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { ListRow, type ListRowProps } from './ListRow'

export function SortableListRow(props: ListRowProps) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: props.issue.id,
  })

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.4 : 1,
    zIndex: isDragging ? 20 : 'auto',
  }

  return (
    <ListRow
      {...props}
      rowRef={setNodeRef}
      rowStyle={style}
      dragHandleProps={{ attributes, listeners }}
    />
  )
}
